import { useMemo, type ReactNode } from 'react';
import { ConsoleCapabilityContext, resolveCapabilities } from '@/auth/consoleCapabilityContext';

/**
 * EAA-1776 (§1b): mounts the fail-closed capability context with the
 * server-computed set from `GET /me/admin`. Component-only module so React
 * fast-refresh stays happy — the context, resolver and `useCan` hook live in
 * `consoleCapabilityContext.ts`.
 */
export function ConsoleCapabilityProvider({
    capabilities,
    children,
}: {
    capabilities?: string[] | null;
    children: ReactNode;
}) {
    const value = useMemo(() => resolveCapabilities(capabilities), [capabilities]);
    return <ConsoleCapabilityContext.Provider value={value}>{children}</ConsoleCapabilityContext.Provider>;
}
